//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  OnDestroy,
  Signal,
  signal,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { 
  animate,
  style,
  transition,
  trigger
} from "@angular/animations";

//local imports
import { 
  Messenger,
  CloseDialogMessage,
  fadeSlideIn,
} from "@app/shared";

import {
  CatalogDataChangedMessage,
  CatalogStateService,
  ExportPackageMessage,
  LoaderMessage,
  ProjectModel
} from "@app/catalog";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonConstants } from "@app/app-common";


@Component({
  selector: 'list-main',
  standalone: false,
  templateUrl: './list-main.component.html',
  styleUrl: './list-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeSlideIn]
})
export class ListMainComponent implements OnDestroy  {

  @ViewChild('exportPackage') exportPackage!: TemplateRef<any>;
  public activeFormTemplate = signal<TemplateRef<any> | null>(null);
  public activeAssignmentTemplate = signal<TemplateRef<any> | null>(null);

  public showAddPopup = signal(false);
  public isLoading = signal(false);
  public constants = CommonConstants;  
  
  public exportedProject = signal<ProjectModel>(undefined);
  public catalogDataChanged: Signal<CatalogDataChangedMessage>;

  public isAssignMode = computed(() => this.activeAssignmentTemplate() !== null);

  public dataLoaded = computed(() => {
    let msg = this.catalogDataChanged();
    return !!msg;
  });

  public companyId = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.companyId;
    return value;
  })


  public roomGroups = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.roomGroups();
    return value;
  });
  
  public rooms = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.rooms();
    return value;
  });

  public departmentGroups = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.departmentGroups();
    return value;
  });



  public departments = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.departments();
    return value;
  });



  public projects = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.projects();
    return value;
  });


  public programs = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.programs();
    return value;
  });


  public categories = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.categories();
    return value;
  });


  public roomContents = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.roomContents();
    return value;
  });


  
  constructor(
    private route: ActivatedRoute,
    private messenger: Messenger,
    private catalogStateService: CatalogStateService
  ) {
  
    this.setupSubscriptions();

    this.activeFormTemplate = signal(undefined);
    this.catalogDataChanged = this.messenger.getSignal(CatalogDataChangedMessage);
    this.catalogStateService.initialize(route);
  }

  private setupSubscriptions() {
    this.messenger.subscribe(this, CloseDialogMessage, msg => {
        this.closeForm();
      });

    this.messenger.subscribe(this, LoaderMessage, (msg) => {
        this.isLoading.set(true);
    });

    this.messenger.subscribe(this, CatalogDataChangedMessage, (msg) => {
      if (msg) {
        this.isLoading.set(false);
      }
    });

    this.messenger.subscribe(this, ExportPackageMessage, (msg) => {
      this.exportedProject.set(msg.project);
      this.activeFormTemplate.set(this.exportPackage);
    });
  }


  public openAddForm(template: TemplateRef<any>): void {
    this.activeFormTemplate.set(template);
  }

  public isFormOpen(): boolean {
    return !!this.activeFormTemplate();
  }




  public loadAssignmentTemplate(template: TemplateRef<any>) {
    this.activeAssignmentTemplate.set(template);
  }


  public applyAssignment() {

  }

  public cancelAssignment() {
    this.activeAssignmentTemplate.set(null);
  }

  private closeForm(): void {
    this.activeFormTemplate.set(null);
  }



  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
